var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrEditResource',{on:{"breadcrumb-data-changed":function($event){return _vm.setBreadcrumb($event.route, $event.routeName)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }